import { render } from "./select-input.vue?vue&type=template&id=0afb813e&scoped=true"
import script from "./select-input.vue?vue&type=script&lang=js"
export * from "./select-input.vue?vue&type=script&lang=js"

import "./select-input.vue?vue&type=style&index=0&id=0afb813e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afb813e"],['__file',"src/views/form/components/select-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0afb813e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0afb813e', __exports__)) {
    console.log('reload')
    api.reload('0afb813e', __exports__)
  }
  
  module.hot.accept("./select-input.vue?vue&type=template&id=0afb813e&scoped=true", () => {
    console.log('re-render')
    api.rerender('0afb813e', render)
  })

}


export default __exports__